import React from 'react';

// local dependencies
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';
import { getLabel } from 'utils/getLabel';
import { entityConfig } from 'config/entity-info/prior-auth-summary.js';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { priorAuthDetailSummary as PriorAuthDetailSummary } from 'ui/views/widgets/priorAuthDetailSummary';
 *
 * // render
 * <PriorAuthDetailSummary propName='propValue'/>
 */
const _priorAuthDetailSummary = ( props ) => {
    const { data, structure } = props.componentData;
    const { state, options } = data;
    const { values, iconsVisibility } = state;
    const { title, primarySection } = structure;
    
    return (
        <div className='ui-prior-auth-detail-summary'>
            
            {/* widget title */}
            <div className='ui-prior-auth-detail-summary__header'>
                <div className='ui-prior-auth-detail-summary__header__title'>
                    { getLabel( title ) }
                </div>
            </div>

            {/* widget body */}
            <div className='ui-prior-auth-detail-summary__body'>
                <div className='ui-prior-auth-detail-summary__body__primary'>
                    <EntityInfoCells
                        className='ui-prior-auth-detail-summary__body__primary__cell'
                        items={ primarySection }
                        values={ values }
                        options={ options }
                        iconsVisibility={ iconsVisibility }
                        entityConfig={ entityConfig }
                    />
                </div>
            </div>
        </div>
    );
};

// set display name
_priorAuthDetailSummary.displayName = 'priorAuthDetailSummary';

// set default props
_priorAuthDetailSummary.defaultProps = {};

// prop types
_priorAuthDetailSummary.propTypes = {};


export const priorAuthDetailSummary = withNetworkState( WidgetPreloader, _priorAuthDetailSummary );
